(function () {
    'use strict';

    angular.module("imApp").factory("listDataLangService", ['$ihttp', function ($ihttp) {
        let service = {
            listDataLanguages: function (parms) {
                return $ihttp.post({
                    method: 2721,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2722,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
